import { TextLink, TextLinkStyle, Theme, useTranslation } from '@nextgen-web-framework/all';
import { keyCheck } from '../../../utils';
import styles from './DispositionStockStatus.module.scss';
import { DispositionStockStatusEnum, Dispositionlabels } from './types/enums';
import { DispositionStockStatusProps } from './types/propsTypes';

export const DispositionStockStatus = ({
  dispositionType,
  dispositionlabels,
  onDispositionLabelClick = () => null,
  dispositionValue,
  className,
  showLinkCTA = true,
}: DispositionStockStatusProps) => {
  const handleKeyPress = (e: React.KeyboardEvent) => keyCheck(e.key) && onDispositionLabelClick();
  const t = useTranslation();
  const transLatedDispositionValue = dispositionValue && t(dispositionValue);

  return (
    <div className={`${styles['disposition-stock-status-component']} ${className}`}>
      <div
        className={styles['disposition-stock-status-component-status']}
        data-testid="disposition-stock-status-test-id"
      >
        {Object.hasOwn(dispositionlabels, dispositionType) && t(dispositionlabels[dispositionType])}
      </div>
      {showLinkCTA && (
        <div data-testid="disposition-label-button" role="button" aria-label={transLatedDispositionValue}>
          <TextLink
            onKeyDown={handleKeyPress}
            onClick={onDispositionLabelClick}
            text={transLatedDispositionValue}
            theme={Theme.ERROR}
            textLinkStyle={TextLinkStyle.UNDERLINE}
          />
        </div>
      )}
    </div>
  );
};

export { DispositionStockStatusEnum, Dispositionlabels };
export type { DispositionStockStatusProps };
